import request from "./request";
// 任务中心
// 获取任务列表
export const getTaskList = (data) => request("/task/getTaskList", data, "POST_JSON");
// 获取失败任务详情
export const getFailTaskDetail = (data) => request("/task/getFailTaskDetail", data, "GET");
// 获取任务详情
export const getDetailTaskList = (data) => request("/task/getDetailTaskList", data, "POST");
// 任务中心复制数据查询
export const queryCommitData = (data) => request("/common/queryCommitData", data, "GET");

// 编辑记录列表
export const editTaskList = (data) => request("/task/editTaskList", data, "POST_JSON");
// 编辑记录详情
export const adEditDetailList = (data) => request("/task/adEditDetailList", data, "POST_JSON");

// 获取Youtube任务列表
export const getYoutubeTask = (data) => request("/task/getYoutubeTask", data, "POST_JSON");
// 获取Youtube任务详情
export const getYoutubeTaskDetail = (data) =>
  request("/task/getYoutubeTaskDetail", data, "POST_JSON");
// Youtube任务失败重试
export const youtubeTaskRetry = (data) => request("/task/youtubeTaskRetry", data, "GET");

// 获取报表任务列表
export const getReportTask = (data) => request("/task/getReportTask", data, "POST_JSON");
// 报表任务失败重试
export const reportTaskRetry = (data) => request("/task/reportTaskRetry", data, "GET");

// 追踪管理
// 获取归因产品下拉列表
export const getConvertProductList = (data) => request("/convert/getConvertProducts", data, "GET");
export const queryDataTrackPara = (data) => request("/convert/queryDataTrackPara", data, "GET");
export const addDataTrackPara = (data) => request("/BIServ/convert/addDataTrackPara", data, "POST");
export const modifyDataTrackPara = (data) => request("/convert/modifyDataTrackPara", data, "POST");
export const deleteDataTrackPara = (data) => request("/convert/deleteDataTrackPara", data, "POST");
//渠道配置
export const queryConvertPara = (data) => request("/convert/queryConvertPara", data, "GET");
export const saveConvertPara = (data) => request("/convert/saveConvertPara", data, "POST");
export const queryCbPara = (data) => request("/convert/queryCbPara", data, "GET");
export const addCbPara = (data) => request("/convert/addCbPara", data, "POST_JSON");
// 归因产品管理
// 查询归因服务产品列表
export const queryConvertProduct = (data) => request("/convert/queryConvertProduct", data, "GET");
// 新增归因服务产品
export const addConvertProduct = (data) => request("/convert/addConvertProduct", data, "POST");
// 修改归因服务产品
export const modifyConvertProduct = (data) =>
  request("/convert/modifyConvertProduct", data, "POST");
// 删除归因服务产品
export const delConvertProduct = (data) => request("/convert/delConvertProduct", data, "GET");
// 主体管理
// 添加投放主体
export const addDeliverySub = (data) => request("/deliverySub/add", data, "POST_JSON");
// 删除投放主体
export const deleteDeliverySub = (data) => request("/deliverySub/delete", data, "GET");
// 投放主体列表
export const getDeliverySubList = (data) => request("/deliverySub/list", data, "GET");
// 修改投放主体
export const updateDeliverySub = (data) => request("/deliverySub/update", data, "POST_JSON");
// 产品管理
// 获取产品列表
export const getProductList = (data) => request("/product/list", data, "POST_JSON");
// 新增产品
export const addProduct = (data) => request("/product/add", data, "POST_JSON");
// 修改产品
export const updateProduct = (data) => request("/product/update", data, "POST_JSON");
// 删除产品
export const deleteProduct = (data) => request("/product/delete", data, "GET");
// 根据包名获取产品信息
export const getProductDetailByPkg = (data) => request("/product/findByPkg", data, "GET");
// 小组列表
export const getSquadList = (data) => request("/common/squadList", data, "GET");
// 工作室列表
export const getGroupList = (data) => request("/common/groupList", data, "GET");
// 产品权限分配
// 产品权限列表
export const getProductPermList = (data) => request("/uapp/getPermAppByPage", data, "POST_JSON");
// 产品列表-筛选框
export const getProductSimpleList = (data) => request("/product/simpleList", data, "GET");
// 修改产品权限
export const updateProductPerm = (data) => request("/uapp/changePerm", data, "POST_JSON");
// 获取投放渠道
export const getMediaSourceList = (data) => request("/product/getMediaSourceList", data, "GET");
/* 渠道管理 */
// 获取媒体渠道分页列表
export const getMediaSourcePageList = (data) => request("/mediaSource/pageList", data, "GET");
// 新增媒体渠道
export const addMediaSource = (data) => request("/mediaSource/add", data, "POST_JSON");
// 修改媒体渠道
export const updateMediaSource = (data) => request("/mediaSource/update", data, "POST_JSON");